import { cachedSerialNames31jc5fovi62px as cachedSerialNames } from './Platform.common.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function missingFieldExceptionWithNewMessage(exception, message) {
  return exception.g1p(message);
}
function jsonCachedSerialNames(_this__u8e3s4) {
  return cachedSerialNames(_this__u8e3s4);
}
//region block: exports
export {
  jsonCachedSerialNames as jsonCachedSerialNameslxufy2gu43jt,
  missingFieldExceptionWithNewMessage as missingFieldExceptionWithNewMessage2gqddjx5jxge9,
};
//endregion

//# sourceMappingURL=JsonInternalDependencies.mjs.map
